var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgErrorIcon = function SvgErrorIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 14 12"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m12.784 8.735-4.22-7.308A1.79 1.79 0 0 0 7 .524c-.653 0-1.238.337-1.565.903l-4.22 7.308a1.79 1.79 0 0 0 0 1.806c.327.566.912.903 1.566.903h8.438c.654 0 1.239-.337 1.565-.903a1.79 1.79 0 0 0 0-1.806m-6.367-4.68a.584.584 0 0 1 1.166 0v2.723a.584.584 0 0 1-1.166 0zM7 9.555a.779.779 0 1 1 .002-1.557A.779.779 0 0 1 7 9.554"
  })));
};
export default SvgErrorIcon;